import Api from 'services/Api'
import ChangesService from 'services/db/Changes'
import {
  ChangeDocsByTypes,
  EventDoc,
  EventParticipantStatus
} from 'types/api/changes'
import { getOrUpdateDeviceId } from 'utils/device'

import { parseDataWithCast } from './changes'

export const PARTICIPANT_STATUS = '/v1/eventsParticipantsStatus/batch'

export interface UpdateParticipantStatusBody {
  _id?: string
  ParticipantsStatus?: EventParticipantStatus
  DeviceChangeID?: string
}

export async function updateParticipantStatus(
  statuses: UpdateParticipantStatusBody[]
) {
  const response = await Api.post(PARTICIPANT_STATUS, {
    DeviceChangeID: getOrUpdateDeviceId(),
    Events: statuses
  })
  const updatedStatuses: Record<string, EventDoc> = parseDataWithCast(
    response.data
  )
  const eventsWithStatuses: ChangeDocsByTypes = {
    Group: {},
    GroupEvent: updatedStatuses,
    Account: {},
    MasterLabel: {},
    Profile: {},
    UserSettings: {},
    Task: {},
    Note: {}
  }
  // The enriched response is authoritative, including omitted inherited links.
  await ChangesService.saveChanges(eventsWithStatuses)
  return updatedStatuses
}
